import React, {useEffect, useState, useRef} from 'react';
import {Theme, Icon, Spacer, Input, Button, ThirdTitle, Toggle,Text,Alert, async} from "@dspworkplace/ui";
import Modal, {useModal} from '../../components/Modal';
import {useForm} from "react-hook-form";
import StationSelector from "../../components/StationSelector";
import {alert} from '../../components/Alert';
import moment from "moment";
import DayPicker from "../../components/Calendar/dayNew";
import API from "./api";
import {toast} from "../../components/Toasts";
import Loading, {LoadingWrapper} from "../../components/Loading";
import {useLocalStorage,getUserId,getFriendlyName,getDateFormat} from "../../Auth";
import { useHistory } from "react-router-dom";
import {FilterWeekDate,NarrativeAutoSave} from "../../hooks/useGlobalData";
import {useSelectedStation} from "../../components/StationSelector";
import { TimelineButton } from './timeline';
import ES from "../../EventSource";

const SummaryButton = () => {
    const [visible, setVisible] = useModal(false);
    // const [currStation] = useLocalStorage('selectedStation');
    const [isResetPassword] = useLocalStorage('isResetPassword');
    const [currStation, ] = useSelectedStation('');
    let history = useHistory();

    const checkSelectedStation = (isResetPassword) => {
        if(isResetPassword === true) {
            toast({
                type: 'warning',
                title: "You must change your password first then you can access other sections.",
                useClose:true,
                timeout: 10000
            })
           return history.push("/edit-profile#user-information")
        } else {
            toast({
                type: 'warning',
                title: "To use any section it's necessary to add one station !!!",
                useClose:true,
                timeout: false
            })
            return history.push("/organization/stations")
        }
    }

    return (
        <>
            <span
                style={{
                    padding: '8px',
                    borderRadius: '8px',
                    cursor: 'pointer',
                    display: 'inline-flex',
                    alignItems: 'center',
                }}
                className="nav-hover-btn"
                onClick={() => {
                    (currStation && isResetPassword != true)
                        ? setVisible(!visible)
                        : checkSelectedStation(isResetPassword);
                }}
            >
                <Icon.CalendarV2 size='20px' />
            </span>
            <Modal
                width={'600px'}
                drawer={'right'}
                title='Station Narrative'
                visible={visible}
                setVisible={setVisible}
                closeOnOverlay={true}
            >
                <SummaryForm />
            </Modal>
        </>
    )
}

const INACTIVITY_TIMEOUT = 60000;
// Must stay well under the backend NARRATIVE_LOCK_TTL (90s) so an active owner never looks abandoned
const LOCK_HEARTBEAT_INTERVAL = 30000;
const DRAFT_BROADCAST_DELAY = 400;
const ACTIVITY_EVENTS = ['input', 'keydown', 'mousedown', 'touchstart'];
const NARRATIVE_FIELDS = ['driversHired', 'driversFired', 'driversQuit', 'scheduledInterviews', 'interviewsCompleted', 'summary'];
const pickNarrativeFields = (values) => NARRATIVE_FIELDS.reduce((fields, key) => ({...fields, [key]: values[key]}), {});

const SummaryForm = () => {
    const {register,handleSubmit,getValues,errors,reset,setValue} = useForm();
    // const [currStation] = useLocalStorage('selected');
    const [currStation, ] = useSelectedStation('');
    const [currDate, setCurrDate] = FilterWeekDate();
    const [selectedStation, setSelectedStation] = useState(currStation);
    const [loading,setLoading] = useState(false);
    const [lockedUser, setLockedUser] = useState(null);
    const [isDownload, setIsDownload] = useState(false);
    const [autoSave, setAutoSave] = NarrativeAutoSave();
    const [updatedDate, setUpdatedDate] = useState();
    const [summaryId, setSummaryId] = useState(null);

    const allValues = getValues();
    const {id,driversHired,driversQuit,driversFired,interviewsScheduled,interviewsCompleted,summary} = allValues;
    const idRef = useRef();
    const ownedSummaryIdRef = useRef(null);
    const fetchGenerationRef = useRef(0);
    const formRef = useRef(null);
    const autoSaveTimerRef = useRef(null);
    const pendingSaveRef = useRef(null);
    const lockRequestRef = useRef(null);
    const draftTimerRef = useRef(null);
    const lastHeartbeatRef = useRef(0);

    const currentUser = getUserId();
    const isCurrentUserLock = (lockByUser) => !!lockByUser && String(lockByUser.id) === String(currentUser);
    const lockForCurrentUser = (id) => {
        setLockedUser({id: currentUser, friendlyName: getFriendlyName()});
        if (id) ownedSummaryIdRef.current = id;
        lastHeartbeatRef.current = Date.now();
    };
    const setCurrentSummaryId = (id) => {
        idRef.current = id;
        setSummaryId(id);
        setValue('id', id);
    };
    const releaseLock = (summaryId, fields = null) => {
        if (!summaryId) return Promise.resolve();

        if (ownedSummaryIdRef.current === summaryId) {
            ownedSummaryIdRef.current = null;
        }
        return API.releaseLock(summaryId, selectedStation, fields);
    };
    const isLockOwner = isCurrentUserLock(lockedUser);
    const isLockedByOther = !!lockedUser && !isLockOwner;

    // Takes the lock (creating the summary if needed). Resolves true when the current user owns it.
    const ensureLock = () => {
        if (ownedSummaryIdRef.current) return Promise.resolve(true);
        if (lockRequestRef.current) return lockRequestRef.current;

        const thisGeneration = fetchGenerationRef.current;
        lockRequestRef.current = API.acquireLock(currDate, selectedStation)
            .then(response => {
                const lock = response?.data?.data?.lock;
                if (!lock) return false;
                if (thisGeneration !== fetchGenerationRef.current) {
                    if (lock.acquired) API.releaseLock(lock.summaryId, selectedStation).catch(() => {});
                    return false;
                }
                if (lock.summaryId) setCurrentSummaryId(lock.summaryId);
                if (lock.acquired) {
                    lockForCurrentUser(lock.summaryId);
                    return true;
                }
                setLockedUser(lock.lockByUser);
                return false;
            })
            .catch(() => false)
            .finally(() => {
                lockRequestRef.current = null;
            });
        return lockRequestRef.current;
    };

    const syncLockOwner = () => {
        const thisGeneration = fetchGenerationRef.current;
        API.fetchSummary(currDate, selectedStation).then(response => {
            if (thisGeneration !== fetchGenerationRef.current) return;
            const fetchedLock = response?.data?.data?.summary?.lockByUser;
            setLockedUser(fetchedLock && !isCurrentUserLock(fetchedLock) ? fetchedLock : null);
        }).catch(() => {});
    };

    const submitHandler = async (data,evt) => {
        let form = evt.target;
        let formButton = form.querySelector('#submit');
        const settlePendingSave = (error) => {
            if (error) pendingSaveRef.current?.reject(error);
            else pendingSaveRef.current?.resolve();
            pendingSaveRef.current = null;
        };

        if(!data.date) {
            alert('You need to provide an date');
            return;
        }
        if(!data.station || data.station === 'all') {
            alert('You need to chose one single station');
            return;
        }


        formButton.disabled = true;

        const acquired = await ensureLock();
        const ownedId = ownedSummaryIdRef.current;
        if (!acquired || !ownedId) {
            formButton.disabled = false;
            settlePendingSave(new Error('lock not held'));
            return;
        }

        if (data.summary == '') {
            data.summary = moment(currDate).format('MM/DD/YYYY');
            setValue('summary', data.summary);
        }

        const thisGeneration = fetchGenerationRef.current;
        try {
            // The backend only saves if this user still holds the lock
            const result = await API.saveNarrative(ownedId, selectedStation, pickNarrativeFields(data));
            const save = result?.data?.data?.save;
            if (!save) throw new Error('update failed');
            // Station/date changed while saving: don't apply the old summary's state to the new one
            const isStale = thisGeneration !== fetchGenerationRef.current;
            if (!save.saved) {
                if (ownedSummaryIdRef.current === ownedId) ownedSummaryIdRef.current = null;
                if (isStale) {
                    settlePendingSave(new Error('lock not held'));
                    return;
                }
                setLockedUser(save.lockByUser);
                toast({
                    type: 'error',
                    title: 'Your changes were not saved because another user has taken over the Narrative.'
                });
                settlePendingSave(new Error('lock not held'));
                return;
            }
            toast({
                type: 'success',
                title: 'Summary information updated successfully.'
            });
            if (!isStale) setUpdatedDate(moment.utc().valueOf() / 1000);
            settlePendingSave();
        } catch {
            alert('Error to update the summary, please contact support.');
            settlePendingSave(new Error('update failed'));
        } finally {
            formButton.disabled = false;
        }
    }

    const generateSummary = async(type) => {
        if (autoSave && !isLockedByOther) {
            try {
                await forceSaveAndWait();
            } catch {
                toast({ type: 'error', title: 'Save failed – generation cancelled' });
                return;
            }
        }

        let tempArray = [];
        setLoading(true);

        tempArray['currentStation'] = selectedStation;
        tempArray['currentDate'] = currDate;
        await API.generateSummary(tempArray).then(result => {
            setSummaryId(result.data.data.dailySummary);
            if(type == 'generate'){
                API.dailySummaryDownload(tempArray).then(result => {
                    if(result.data.data.pdf && result.data.data.pdf != null){
                        window.open(result.data.data.pdf);
                    }
                });
            }
             reset({
                    driversHired:allValues.driversHired,
                    driversQuit:allValues.driversQuit,
                    driversFired:allValues.driversFired,
                    scheduledInterviews:allValues.scheduledInterviews,
                    interviewsCompleted:allValues.interviewsCompleted,
                    summary:allValues.summary,
                    id:allValues.id,
                    lockByUser:allValues.lockByUser
                });
            setLoading(false);
        });
        setIsDownload(true);
    }
    const summaryDownload = async(type) => {
        let tempArray = [];
        setLoading(true);
        tempArray['currentStation'] = selectedStation;
        tempArray['currentDate'] = currDate;
        await API.dailySummaryDownload(tempArray).then(result => {
            setLoading(false);
            if(result.data.data.pdf && result.data.data.pdf != null){
                window.open(result.data.data.pdf);
            }
        });

    };
    useEffect(() => {
        if (currStation != null) {
            const searchStation = typeof(currStation) === 'object' ? currStation[0] : currStation;
            if(!searchStation || !currDate) return;
            setSelectedStation(searchStation);
            reset({date:currDate,station:searchStation})
        }
    }, []);

    useEffect(() => {
        return () => {
            if (autoSaveTimerRef.current) {
                clearTimeout(autoSaveTimerRef.current);
                autoSaveTimerRef.current = null;
            }
            if (draftTimerRef.current) {
                clearTimeout(draftTimerRef.current);
                draftTimerRef.current = null;
            }
        };
    }, []);

    // Live lock + field updates for this station/date: {companyId}/{stationId}/narrative/{YYYY-MM-DD}
    useEffect(() => {
        if (!selectedStation || !currDate) return;

        const applyRemoteFields = (fields) => {
            if (!fields) return;
            Object.keys(fields).forEach(key => {
                if (NARRATIVE_FIELDS.includes(key)) setValue(key, fields[key] ?? '');
            });
        };

        const es = new ES(`narrative/${currDate}`, false, null, selectedStation);
        es.onmessage = ({event, data}) => {
            if (!data || data.date !== currDate || String(data.stationId) !== String(selectedStation)) return;

            if (data.summaryId && !idRef.current) setCurrentSummaryId(data.summaryId);

            switch (event) {
                case 'NARRATIVE_LOCKED':
                    if (!isCurrentUserLock(data.lockByUser)) {
                        ownedSummaryIdRef.current = null;
                        setLockedUser(data.lockByUser);
                    }
                    break;
                case 'NARRATIVE_UNLOCKED':
                    applyRemoteFields(data.fields);
                    setLockedUser(prev => (prev && !isCurrentUserLock(prev) ? null : prev));
                    break;
                case 'NARRATIVE_DRAFT':
                case 'NARRATIVE_SAVED':
                    // Never overwrite what the lock owner is typing
                    if (!ownedSummaryIdRef.current) applyRemoteFields(data.fields);
                    if (event === 'NARRATIVE_SAVED' && data.updatedAt) setUpdatedDate(data.updatedAt);
                    break;
                default:
            }
        };

        return () => es.close();
    }, [selectedStation, currDate]);

    useEffect(()=>{
        if(!selectedStation || !currDate){
            toast({
                type: 'error',
                title: 'Error',
                content: 'This page needs an date and a single station to work'
            })
            return;
        }

        const thisGeneration = ++fetchGenerationRef.current;

        const hadPendingEdits = !!autoSaveTimerRef.current;
        if (autoSaveTimerRef.current) {
            clearTimeout(autoSaveTimerRef.current);
            autoSaveTimerRef.current = null;
        }
        if (draftTimerRef.current) {
            clearTimeout(draftTimerRef.current);
            draftTimerRef.current = null;
        }

        const toRelease = ownedSummaryIdRef.current;
        ownedSummaryIdRef.current = null;
        if (toRelease) {
            releaseLock(toRelease, hadPendingEdits ? pickNarrativeFields(getValues()) : null).catch(() => {});
        }

        setLoading(true);
        setLockedUser(null);
        setIsDownload(false);
        setSummaryId(null);

        API.fetchSummary(currDate, selectedStation).then(
            async (response) => {
                if (thisGeneration !== fetchGenerationRef.current) {
                    return;
                }

                if(response.data.data.summary){
                    const summary = response.data.data.summary;
                    reset({
                        driversHired:summary.driversHired,
                        driversQuit:summary.driversQuit,
                        driversFired:summary.driversFired,
                        scheduledInterviews:summary.scheduledInterviews,
                        interviewsCompleted:summary.interviewsCompleted,
                        summary:summary.summary,
                        id:summary.id,
                        lockByUser:summary.lockByUser?.id
                    });

                    setSummaryId(summary.id);
                    setUpdatedDate(summary.updatedDate.timestamp);
                    idRef.current = summary.id;

                    if(summary.reportUrl != null){
                        setIsDownload(true);
                    }

                }else{
                    reset({
                        driversHired:null,
                        driversQuit:null,
                        driversFired:null,
                        scheduledInterviews:null,
                        interviewsCompleted:null,
                        summary:null,
                        id:null,
                        lockByUser:null

                    });
                    setIsDownload(false);
                    setUpdatedDate(null);
                }
                setLoading(false);

                // The lock is taken on first focus/typing (ensureLock), not on open.
                // A lock left by this same user (e.g. a closed drawer) is treated as free and re-acquired on focus.
                const fetchedLock = response.data.data.summary?.lockByUser;
                setLockedUser(fetchedLock && !isCurrentUserLock(fetchedLock) ? fetchedLock : null);
            },
            (error) => {
                if (thisGeneration !== fetchGenerationRef.current) return;
                toast({
                    type: 'error',
                    title: 'Error',
                    content: error.response ? error.response.data.message : 'Unexpected error'
                })
                setLockedUser(null);
                setLoading(false);
            }
        );
    },[selectedStation,currDate])

    useEffect(()=>{
        const ownedId = summaryId;
        if (!ownedId || ownedId <= 0 || !isLockOwner) return;
        ownedSummaryIdRef.current = ownedId;

        let cancelled = false;
        let released = false;
        let idleTimer = null;
        let idleSaveInFlight = false;

        const handlePageHide = () => {
            if (released || ownedSummaryIdRef.current !== ownedId) return;
            released = true;
            ownedSummaryIdRef.current = null;
            API.releaseLockOnUnload(ownedId, selectedStation);
        };

        // A bfcache restore keeps this closure with released = true; drop ownership so a re-acquire reruns this effect
        const handlePageShow = (e) => {
            if (!e.persisted || !released) return;
            setLockedUser(null);
            syncLockOwner();
        };

        const resetIdleTimer = () => {
            clearTimeout(idleTimer);
            idleTimer = setTimeout(saveAndReleaseOnIdle, INACTIVITY_TIMEOUT);
        };

        // Keeps lockedAt fresh while the owner is active but not typing (typing already sends drafts)
        const sendHeartbeat = () => {
            if (Date.now() - lastHeartbeatRef.current < LOCK_HEARTBEAT_INTERVAL) return;
            lastHeartbeatRef.current = Date.now();
            API.broadcastDraft(ownedId, selectedStation, {}).then(response => {
                if (cancelled || response?.data?.data?.draft?.accepted !== false) return;
                released = true;
                ownedSummaryIdRef.current = null;
                syncLockOwner();
            }).catch(() => {});
        };

        const handleActivity = (e) => {
            if (!formRef.current?.contains(e.target)) return;
            resetIdleTimer();
            sendHeartbeat();
        };

        const saveAndReleaseOnIdle = async () => {
            if (idleSaveInFlight || cancelled) return;
            if (autoSaveTimerRef.current || pendingSaveRef.current || document.getElementById('submit')?.disabled) {
                resetIdleTimer();
                return;
            }

            idleSaveInFlight = true;
            try {
                // Saves and releases in one call; the backend only does it if this user still holds the lock
                const response = await API.releaseLock(ownedId, selectedStation, pickNarrativeFields(getValues()));
                if (cancelled) return;
                const release = response?.data?.data?.release;
                if (!release) throw new Error('release failed');
                released = true;
                ownedSummaryIdRef.current = null;
                setValue('lockByUser', '');
                if (!release.released) {
                    setLockedUser(release.lockByUser);
                    return;
                }
                setUpdatedDate(moment.utc().valueOf() / 1000);
                setLockedUser(null);
                toast({
                    type: 'info',
                    title: 'Summary saved and released after 1 minute of inactivity.'
                });
            } catch {
                if (!cancelled) resetIdleTimer();
            } finally {
                idleSaveInFlight = false;
            }
        };

        window.addEventListener('pagehide', handlePageHide);
        window.addEventListener('pageshow', handlePageShow);
        ACTIVITY_EVENTS.forEach(evt => document.addEventListener(evt, handleActivity, true));
        resetIdleTimer();

        return () => {
            cancelled = true;
            clearTimeout(idleTimer);
            window.removeEventListener('pagehide', handlePageHide);
            window.removeEventListener('pageshow', handlePageShow);
            ACTIVITY_EVENTS.forEach(evt => document.removeEventListener(evt, handleActivity, true));

            if (!released && ownedSummaryIdRef.current === ownedId) {
                releaseLock(ownedId);
            }
        };
    },[isLockOwner, summaryId]);


    const handleAutoSave = () => {
        if (autoSaveTimerRef.current) clearTimeout(autoSaveTimerRef.current);
        autoSaveTimerRef.current = setTimeout(() => {
            autoSaveTimerRef.current = null;
            document.getElementById('submit')?.click();
        },3000)

    }

    const broadcastDraftSoon = () => {
        if (draftTimerRef.current) return;
        const thisGeneration = fetchGenerationRef.current;
        draftTimerRef.current = setTimeout(() => {
            draftTimerRef.current = null;
            if (thisGeneration !== fetchGenerationRef.current) return;
            const ownedId = ownedSummaryIdRef.current;
            if (!ownedId) return;
            lastHeartbeatRef.current = Date.now();
            API.broadcastDraft(ownedId, selectedStation, pickNarrativeFields(getValues())).then(response => {
                if (response?.data?.data?.draft?.accepted !== false) return;
                if (ownedSummaryIdRef.current === ownedId) ownedSummaryIdRef.current = null;
                if (thisGeneration === fetchGenerationRef.current) syncLockOwner();
            }).catch(() => {});
        }, DRAFT_BROADCAST_DELAY);
    }

    const onFieldChange = async () => {
        if (!(await ensureLock())) return;
        broadcastDraftSoon();
        if (autoSave) handleAutoSave();
    }

    const onFieldFocus = (e) => {
        if (NARRATIVE_FIELDS.includes(e.target.name)) ensureLock();
    }

    const forceSaveAndWait = async () => {
        if (autoSaveTimerRef.current) {
            clearTimeout(autoSaveTimerRef.current);
            autoSaveTimerRef.current = null;
        }

        const submitBtn = document.getElementById('submit');

        if (submitBtn?.disabled || pendingSaveRef.current) {
            try {
                await new Promise((resolve, reject) => {
                    const prev = pendingSaveRef.current;
                    pendingSaveRef.current = {
                        resolve: v => { prev?.resolve(v); resolve(v); },
                        reject: e => { prev?.reject(e); reject(e); }
                    };

                    setTimeout(() => {
                        if (pendingSaveRef.current) {
                            pendingSaveRef.current.reject(new Error('timeout'));
                            pendingSaveRef.current = null;
                        }
                    }, 15000);
                });
            } catch {}
        }

        return new Promise((resolve, reject) => {
            pendingSaveRef.current = { resolve, reject };
            document.getElementById('submit')?.click();
            setTimeout(() => {
                if (pendingSaveRef.current) {
                    pendingSaveRef.current.reject(new Error('timeout'));
                    pendingSaveRef.current = null;
                }
            }, 15000);
        });
    };

    if(loading) return (
        <LoadingWrapper>
            <Loading style={{height:'80px',marginTop:'20px'}} />
        </LoadingWrapper>
    )

    return (
        <>
            <form ref={formRef} onSubmit={handleSubmit(submitHandler)} onFocusCapture={onFieldFocus}>
                <Spacer inline style={{display:'flex',alignItems:'flex-end',position:'relative',zIndex:5}} >
                    <input type='hidden' name='id' ref={register} />
                    <input type='hidden' name='lockByUser' ref={register} />
                    <DayPicker
                        label='Date'
                        className='picker'
                        name='date'
                        ref={register}
                        size={'small'}
                        useControllers={true}
                        defaultValue={moment(currDate).format('YYYY-MM-DD')}
                        onChange={(date) => {
                            if(!date.original) return;
                            const localDate = moment(date.original, getDateFormat(selectedStation)).format('YYYY-MM-DD');
                            if(localDate === currDate) return;
                            setCurrDate(localDate);                            
                        }}
                        displayFormat={getDateFormat(selectedStation)}
                    />
                    <Spacer inline left={5}>
                        <StationSelector
                            name='station'
                            size='small'
                            showAllOption={false}
                            ref={register}
                            onChange={(value)=>{
                                const searchStation = typeof(value) === 'object' ? value[0] : value;
                                setSelectedStation(searchStation);
                            }}
                        />
                    </Spacer>
                </Spacer>
                {isLockedByOther &&
                <Spacer top={5}>
                    <ThirdTitle>This summary is open by user {lockedUser.friendlyName}</ThirdTitle>
                </Spacer>
                }
                <>
                    <Spacer top={5} bottom={1}>
                        <ThirdTitle>Drivers</ThirdTitle>
                    </Spacer>
                    <Spacer inline>
                        <Input
                            name='driversHired'
                            ref={register}
                            valid={driversHired && !errors.driversHired}
                            label='Hired'
                            type='number'
                            size='small'
                            readOnly={isLockedByOther}
                            onChange={onFieldChange}
                        />
                    </Spacer>
                    <Spacer inline left={5}>
                        <Input
                            name='driversFired'
                            ref={register}
                            valid={driversFired && !errors.driversFired}
                            label='Fired'
                            type='number'
                            size='small'
                            readOnly={isLockedByOther}
                            onChange={onFieldChange}
                        />
                    </Spacer>
                    <Spacer inline left={5}>
                        <Input
                            name='driversQuit'
                            ref={register}
                            valid={driversQuit && !errors.driversQuit}
                            label='Quit'
                            type='number'
                            size='small'
                            readOnly={isLockedByOther}
                            onChange={onFieldChange}
                        />
                    </Spacer>

                    <Spacer top={5} bottom={1}>
                        <ThirdTitle>Interviews</ThirdTitle>
                    </Spacer>

                    <Spacer inline>
                        <Input
                            name='scheduledInterviews'
                            ref={register}
                            valid={interviewsScheduled && !errors.interviewsScheduled}
                            label='Scheduled'
                            type='number'
                            size='small'
                            readOnly={isLockedByOther}
                            onChange={onFieldChange}
                        />
                    </Spacer>
                    <Spacer inline left={5}>
                        <Input
                            name='interviewsCompleted'
                            ref={register}
                            valid={interviewsCompleted && !errors.interviewsCompleted}
                            label='Completed'
                            type='number'
                            size='small'
                            readOnly={isLockedByOther}
                            onChange={onFieldChange}
                        />
                    </Spacer>

                    <Spacer top={5} bottom={1}>
                        <ThirdTitle>Details</ThirdTitle>
                    </Spacer>

                    <Spacer inline>
                        <Input
                            name='summary'
                            ref={register}
                            valid={summary && !errors.summary}
                            label='Summary'
                            type='number'
                            as='textarea'
                            size='big'
                            style={{height:120}}
                            readOnly={isLockedByOther}
                            onChange={onFieldChange}
                            placeholder={moment(currDate).format(getDateFormat(selectedStation))}
                        />
                    </Spacer>


                    <Spacer top={5} bottom={3}>
                        <Button type='primary' id={'submit'} disabled={isLockedByOther} style={{width:'100%',opacity: autoSave || isLockedByOther ? 0.3 : 1}}>Save</Button>
                    </Spacer>
                    <div>
                        <Toggle name='toogle' on={autoSave} onText='Auto Save' onChange={(e) => setAutoSave(e.target.checked)} style={{ position: 'relative' }} />
                        <TimelineButton station={selectedStation} date={currDate} />
                        <Spacer top={3} />
                        {updatedDate && autoSave && <Text style={{fontWeight:400,color:'#ccc'}}>Last Saved {moment.duration(moment().diff(moment.unix(updatedDate))).humanize()} ago</Text>}
                    </div>
                </>
            </form>

            {isDownload == false ? <>
                        { !isLockedByOther ? (autoSave ? <Alert.Warning
                            content='Please wait 5 sec to allow any changes above to propagate before using the download feature.'
                        /> :<Alert.Warning
                            content='Please save your changes first before using the download feature.'
                        />): '' }
                        <Spacer top={2} bottom={1}>
                        <Button  style={{width:'100%'}} onClick={()=>{generateSummary('generate')}}>Generate & Download</Button>
                        </Spacer>
                        </> : <>
                        <Spacer top={2} bottom={1}>
                        <Button  style={{width:'100%'}} onClick={()=>{generateSummary('regenerate')}}>Re Generate </Button>
                        </Spacer>
                        <Spacer top={2} bottom={1}>
                        <Button  style={{width:'100%'}} onClick={()=>{summaryDownload()}}>Download</Button>
                        </Spacer>
                        </>}

        </>
    )
}


export {SummaryButton};
export default SummaryForm;
